// extracted by mini-css-extract-plugin
export var optionGrid = "_4y-7";
export var optionList = "_4y-6";
export var questionsBlock = "_4y-9";
export var spacer = "_4y-5";
export var stepCenteredContent = "_4y-3";
export var stepInner = "_4y-0";
export var stepInnerFullWidth = "_4y-1";
export var stepInnerLockScroll = "_4y-2";
export var stepTransitionFrame = "_4y-4";
export var welcomeBlock = "_4y-8";